var _g, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSCon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 40,
    viewBox: "0 0 93 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_59_2930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 18C4 9.16344 11.1634 2 20 2H73C81.8366 2 89 9.16344 89 18C89 26.8366 81.8366 34 73 34H20C11.1634 34 4 26.8366 4 18Z",
    fill: "#282D4B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.267 16.618H43.217V19.972H44.296V11.314H43.217V13.524H41.267V14.382H43.217V15.747H41.267V16.618ZM41.605 17.827L41.54 17.034C41.059 17.099 40.539 17.138 40.019 17.177V13.108H41.176V12.25H35.04V13.108H36.197V17.32C35.937 17.333 35.69 17.333 35.443 17.333H34.728L34.845 18.217C36.717 18.217 39.382 18.178 41.605 17.827ZM37.224 17.307V13.108H38.979V17.242C38.394 17.281 37.796 17.294 37.224 17.307ZM44.595 22.702V21.831H37.887V19.27H36.821V22.702H44.595ZM55.151 22.988V11.301H54.085V22.988H55.151ZM49.431 12.159C47.624 12.159 46.311 13.277 46.311 14.902C46.311 16.527 47.624 17.645 49.431 17.645C51.251 17.645 52.551 16.527 52.551 14.902C52.551 13.277 51.251 12.159 49.431 12.159ZM49.431 13.069C50.64 13.069 51.511 13.81 51.511 14.902C51.511 15.981 50.64 16.735 49.431 16.735C48.222 16.735 47.351 15.981 47.351 14.902C47.351 13.81 48.222 13.069 49.431 13.069ZM45.726 19.53L45.856 20.427C47.975 20.427 50.77 20.401 53.409 19.92L53.318 19.127C50.744 19.504 47.871 19.53 45.726 19.53ZM66.149 22.988V11.301H65.083V22.988H66.149ZM60.741 14.408V12.315H59.688V14.408C59.688 16.644 58.258 18.841 56.555 19.673L57.205 20.544C58.57 19.816 59.688 18.412 60.221 16.631C60.78 18.308 61.872 19.66 63.224 20.323L63.861 19.465C62.145 18.698 60.741 16.54 60.741 14.408ZM73.559 14.291H76.094V17.333H77.173V11.314H76.094V13.42H73.559V14.291ZM73.832 17.086L74.378 16.254C72.701 15.695 71.518 14.291 71.518 12.757V11.678H70.465V12.757C70.465 14.434 69.308 15.929 67.553 16.514L68.112 17.359C69.477 16.852 70.517 15.838 71.024 14.525C71.531 15.721 72.532 16.631 73.832 17.086ZM77.615 22.806V21.961H70.738V20.713H77.173V17.918H69.659V18.763H76.12V19.907H69.685V22.806H77.615Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 11.8333H26.1667V18.3333C26.1667 20.0822 24.7489 21.5 23 21.5H19.6667C17.9178 21.5 16.5 20.0822 16.5 18.3333V11.8333ZM17.5 12.8333V18.3333C17.5 19.5299 18.4701 20.5 19.6667 20.5H23C24.1967 20.5 25.1667 19.5299 25.1667 18.3333V12.8333H17.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3334 12.8333H26.1667V11.8333H27.3334C28.1618 11.8333 28.8334 12.5049 28.8334 13.3333V15.3333C28.8334 16.1618 28.1618 16.8333 27.3334 16.8333H26.1667V15.8333H27.3334C27.6095 15.8333 27.8334 15.6095 27.8334 15.3333V13.3333C27.8334 13.0572 27.6095 12.8333 27.3334 12.8333Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3334 23.8333H15.3334V22.8333H27.3334V23.8333Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_59_2930",
    x: 0,
    y: 0,
    width: 93,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_59_2930"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_59_2930",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSCon);
export default __webpack_public_path__ + "static/media/s_con.ab16c6ea1367164692979a3b36e201e6.svg";
export { ForwardRef as ReactComponent };